export default {"src":"/_next/static/image/assets/Illustrations/apple_podcast.a49ca4cb815814697e23078f77bafb34.svg","height":26,"width":26};